import { render, staticRenderFns } from "./RatingStar.vue?vue&type=template&id=a50e0556&scoped=true"
import script from "./RatingStar.vue?vue&type=script&lang=js"
export * from "./RatingStar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a50e0556",
  null
  
)

export default component.exports